import { lazyLoad } from '~/src/shared/utils/loadable';

export const UserWithdrawPage = lazyLoad(
  () => import('./index'),
  (module) => module.Withdraw,
);
